import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../api/axiosConfig";
import {
  deleteTickerFailure,
  deleteTickerRequest,
  deleteTickerSuccess,
  fetchSubscriptionStatusFailure,
  fetchSubscriptionStatusRequest,
  fetchSubscriptionStatusSuccess,
  reactivateTickerFailure,
  reactivateTickerRequest,
  reactivateTickerSuccess,
} from "../slice/myPageSlice";
import { fetchSubsRequested, fetchAlertsRequested } from "../slice/alertsSlice";

function getErrorMessage(e: any) {
  return e?.response?.data?.message || e?.message || "요청 처리 중 오류가 발생했습니다.";
}

function* fetchSubscriptionStatusSaga(
    action: ReturnType<typeof fetchSubscriptionStatusRequest>
): any {
  try {
    const userId = action.payload?.userId;
    console.log("[myPageSaga] request userId=", userId);
    console.log("[myPageSaga] request", action.payload);
    console.log("[myPageSaga] calling /billing/subscription-status");
    if (!userId) {
      throw new Error("userId가 없어 구독 상태를 조회할 수 없습니다.");
    }

    const {data} = yield call(api.get, "/billing/subscription-status", {
      params: {userId},
    });

    console.log("[myPageSaga] response=", data);

    yield put(
        fetchSubscriptionStatusSuccess({
          active: !!data?.active,
          nextBillingDate: data?.nextBillingDate ?? data?.next_billing_date ?? null,
          telegramLinked: data?.telegramLinked ?? data?.telegram_linked ?? false,
          cancelAtPeriodEnd: !!(data?.cancelAtPeriodEnd ?? data?.cancel_at_period_end),
          plan: data?.plan ?? null,
          status: data?.status ?? null,
        })
    );
  } catch (e: any) {
    console.error("[myPageSaga] failure=", e);
    yield put(fetchSubscriptionStatusFailure(getErrorMessage(e)));
  }
}

function* reactivateTickerSaga(action: ReturnType<typeof reactivateTickerRequest>): any {
  const { subId } = action.payload;
  try {
    yield call(api.put, `/alerts/subscriptions/${subId}`, { isActive: true });
    yield put(reactivateTickerSuccess({ subId }));
    yield put(fetchSubsRequested());
  } catch (e: any) {
    yield put(reactivateTickerFailure({ subId, error: getErrorMessage(e) }));
  }
}

function* deleteTickerSaga(action: ReturnType<typeof deleteTickerRequest>): any {
  const { subId } = action.payload;
  try {
    yield call(api.delete, `/alerts/subscriptions/${subId}`);
    yield put(deleteTickerSuccess({ subId }));
    yield put(fetchSubsRequested());
    yield put(fetchAlertsRequested());
  } catch (e: any) {
    yield put(deleteTickerFailure({ subId, error: getErrorMessage(e) }));
  }
}

export default function* myPageSaga() {
  yield takeLatest(fetchSubscriptionStatusRequest.type, fetchSubscriptionStatusSaga);
  yield takeLatest(reactivateTickerRequest.type, reactivateTickerSaga);
  yield takeLatest(deleteTickerRequest.type, deleteTickerSaga);
}